export const Roles = [{
  name: 'Carrier Admin - I',
  value: 'HC_CARRIER_ADMIN'
}, {
  name: 'Supplier Admin',
  value: 'HC_SUPPLIER_ADMIN'
}, {
  name: 'Customer Admin',
  value: 'HC_CUSTOMER_ADMIN'
}, {
  name: 'Carrier Dispatcher',
  value: 'HC_CARRIER_DISPATCHER'
}, {
  name: 'Carrier Accounting',
  value: 'HC_CARRIER_ACCOUNTING'
}, {
  name: 'Customer User',
  value: 'HC_CUSTOMER_USER'
}, {
  name: 'Supplier User',
  value: 'HC_SUPPLIER_USER'
}, {
  name: 'Carrier Admin - II',
  value: 'HC_CARRIER_BROKER_ADMIN'
}, {
  name: 'Carrier Broker',
  value: 'HC_CARRIER_BROKER_USER'
}];
